// Document Types are company-configured (an admin can add one any time), so
// there is no fixed enum to hand-pick colors for — a deterministic hash into
// antd's own preset Tag palette gives every type a stable color, without a
// second color system or a config field admins would have to maintain.
const TAG_COLORS = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple"
] as const

export const documentTypeTagColor = (value: string): string => {
  let hash = 0
  for (let i = 0; i < value.length; i++) hash = (hash * 31 + value.charCodeAt(i)) >>> 0
  return TAG_COLORS[hash % TAG_COLORS.length]
}
